import { createFileRoute } from '@tanstack/react-router';

import { AdminAiCostsView } from 'src/sections/admin/ai-costs-view';

export const Route = createFileRoute('/admin-skidog/ai-costs')({
  component: AdminAiCostsPage,
});

function AdminAiCostsPage() {
  return <AdminAiCostsView />;
}
